import createAction from './';

export const SET_ROUTE_TO_REDIRECT = createAction('SET_ROUTE_TO_REDIRECT');
export const RESET_ROUTE_TO_REDIRECT = createAction('RESET_ROUTE_TO_REDIRECT');

export const setRouteToRedirect = (routeToRedirect) => ({ type: SET_ROUTE_TO_REDIRECT, payload: { routeToRedirect } });
export const resetRouteToRedirect = () => ({ type: RESET_ROUTE_TO_REDIRECT });
